<div id="ach-r-pay-due">
  <div>
    <div class="main_profile">
      <div class="modal-header switch_header">
        <ng-container>
            <div class="col-lg-12 col-xl-12 col-12" >
              <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
                Pay Amount Due:  <strong style="color: black"> {{ (data.total_due | currency:'USD':'symbol':'1.2-2') }} USD</strong>
              </h3>
            </div>
        </ng-container>
      </div>
      <div class="modal-body bg-white body-content">
        <ng-container>
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-12" >
              <h3 class="profile_body pl-lg-2 pt-lg-2 pb-2 offset-0">
                Proceeding with this action will allow PayArc to debit  <strong style="color: black">{{ (data.total_due | currency:'USD':'symbol':'1.2-2') }} USD</strong> from the personal bank account on file.
              </h3>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="p-0">
        <div class="dropdown-footer">
          <div class="row">
            <div class="col-sm-4 col-6 pl-xl-4 pl-lg-4 offset-4">
              <button class="btn btn-outline-secondary lg-btn cancel_btn" (click)="closeAction()" >Cancel</button>
            </div>
            <div class="col-sm-4 col-6">
              <button class="btn btn-default lg-btn ok-btn" (click)="payDue()" >Ok</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
